import React from 'react';
import { Typography, AppBar } from '@material-ui/core';
import { makeStyles, ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import VideoPlayer from './components/VideoPlayer';
import Sidebar from './components/Sidebar';
import Notifications from './components/Notifications';



import GroupRoundedIcon from '@material-ui/icons/GroupRounded';

import zoom from "./zoomlogo.png"

const useStyles = makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: '30px 100px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '600px',
    border: '2px solid black',

    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
  image: {
    marginLeft: '15px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
}));



const App = () => {
  const classes = useStyles();

  return (

    <div class="flex flex-col items-center">

      <div class="p-24 flex items-center space-x-4">
        <img class="h-24 w-24" src={zoom} alt="ChitChat Logo" />
        <div>
          <h1 class="text-3xl font-medium text-white">Video Chat - Zoom Clone</h1>
          <p class="text-xl text-gray-500">You have a new Room!</p>
        </div>
      </div>
      <VideoPlayer />

      <Sidebar>
        <Notifications />
      </Sidebar>

    </div>
  );
};

export default App;
